import {
  Box,
  Button,
  Divider,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Stack,
  Text,
} from '@chakra-ui/react';
import { BellIcon } from '@heroicons/react/outline';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useTranslations } from 'use-intl';

import { useUser } from '@blockpulse3/web-client/auth';

dayjs.extend(relativeTime);

type Props = unknown;

export function SettingsNotifications(): JSX.Element {
  const i18nSettingsMenu = useTranslations('SettingsMenu');

  const { user } = useUser();

  return (
    <Popover isLazy placement="auto-end">
      <PopoverTrigger>
        <Button leftIcon={<BellIcon height="20" width="20" />} variant="menu-button">
          {i18nSettingsMenu('Notifications')}
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverBody maxHeight="500px" overflowY="scroll" p="0">
            {user?.uiNotifications?.length ? (
              user?.uiNotifications?.map((notification, index) => {
                return (
                  <Box key={notification.id} p="0">
                    {index !== 0 && <Divider borderColor="gray.300" />}
                    <Stack p="3" spacing="2" textAlign="left">
                      <Text fontSize="sm" fontWeight="500">
                        {notification.textFr}
                      </Text>
                      <Text
                        color="gray.500"
                        fontSize="xs"
                        fontWeight="600"
                        sx={{
                          ':first-letter': {
                            textTransform: 'uppercase',
                          },
                        }}
                      >
                        {dayjs(notification.createdAt).fromNow()}
                      </Text>
                    </Stack>
                  </Box>
                );
              })
            ) : (
              <Stack p="3" spacing="2">
                <Text fontSize="md" fontWeight="500">
                  {i18nSettingsMenu('NoNotification')}
                </Text>
              </Stack>
            )}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}

export type SettingsNotificationsProps = Props;
